import { render, staticRenderFns } from "./ModerationRibbon.vue?vue&type=template&id=00277cf0&scoped=true&"
import script from "./ModerationRibbon.vue?vue&type=script&lang=js&"
export * from "./ModerationRibbon.vue?vue&type=script&lang=js&"
import style0 from "./ModerationRibbon.vue?vue&type=style&index=0&id=00277cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00277cf0",
  null
  
)

export default component.exports